<template>
    <flex-container>
        <template
            v-for="(option, index) in localQuickOptions"
            :key="index"
        >
            <card-expandable with-content with-collapse-arrow>
                <svg-icon
                    :icon="MessageMinusIcon"
                    :size="IconSize.xs"
                    :color="'gray-400'"
                    is-custom-icon
                />
                {{ option.shortMessage }}

                <template #content>
                    <form-validation v-slot="{ bindings: quickOptionsBindings }">
                        <flex-container>
                            <flex-container
                                direction="column"
                                justify-content="space-between"
                                :gap="Size.sm"
                                :size="9"
                            >
                                <flex-container
                                    :gap="Size.xs"
                                    align-items="center"
                                    no-wrap
                                >
                                    <country-flag
                                        country-code="nl"
                                        :size="IconSize.sm"
                                    />
                                    <text-heading sub>
                                        Nederlands
                                    </text-heading>
                                </flex-container>
                                <flex-container
                                    direction="column"
                                    :gap="Size.sm"
                                >
                                    <flex-container no-wrap>
                                        <flex-container
                                            size="auto"
                                            height="full"
                                            direction="column"
                                            justify-content="space-around"
                                            justify-items="left"
                                            :padding-top="Size.xs"
                                        >
                                            <div>
                                                <svg-icon
                                                    :icon="MessageMinusIcon"
                                                    :size="IconSize.xs"
                                                    :color="'gray-400'"
                                                    is-custom-icon
                                                />
                                            </div>
                                            <div>
                                                <svg-icon
                                                    :icon="MessageLinesIcon"
                                                    :size="IconSize.xs"
                                                    :color="'gray-400'"
                                                    is-custom-icon
                                                />
                                            </div>
                                        </flex-container>
                                        <flex-container
                                            align-items="center"
                                            align-content="space-around"
                                            :gap="Size.sm"
                                            class="text-content"
                                            size="auto"
                                        >
                                            <flex-container align-items="center" :gap="Size.sm">
                                                <template v-if="editingQuickOptionNL?.id === option.id">
                                                    <input-group
                                                        v-model.trim="editingQuickOptionNL.shortMessage"
                                                        :schema="string().max(255).required()"
                                                    >
                                                        <template #input>
                                                            <text-input />
                                                        </template>
                                                    </input-group>
                                                </template>
                                                <template v-else>
                                                    <text-decorator>
                                                        {{ option.shortMessage }}
                                                    </text-decorator>
                                                </template>
                                            </flex-container>

                                            <horizontal-line
                                                v-if="editingQuickOptionNL?.id !== option.id"
                                                no-margin
                                            />

                                            <flex-container
                                                align-items="center"
                                                :gap="Size.sm"
                                            >
                                                <template v-if="editingQuickOptionNL?.id === option.id">
                                                    <input-group
                                                        v-model.trim="editingQuickOptionNL.message"
                                                        :schema="string().max(255).required()"
                                                    >
                                                        <template #input>
                                                            <text-input />
                                                        </template>
                                                    </input-group>
                                                </template>
                                                <template v-else>
                                                    <text-decorator>
                                                        {{ option.message }}
                                                    </text-decorator>
                                                </template>
                                            </flex-container>
                                        </flex-container>
                                    </flex-container>
                                </flex-container>

                                <horizontal-line
                                    v-if="props.englishSupportEnabled"
                                    no-margin
                                />

                                <!-- engels -->
                                <template
                                    v-if="props.englishSupportEnabled"
                                >
                                    <flex-container
                                        :gap="Size.xs"
                                        align-items="center"
                                        no-wrap
                                    >
                                        <country-flag
                                            country-code="gb"
                                            :size="IconSize.sm"
                                        />
                                        <text-heading sub>
                                            Engels
                                        </text-heading>
                                    </flex-container>
                                    <flex-container>
                                        <flex-container
                                            size="auto"
                                            direction="column"
                                            justify-content="space-around"
                                            :padding-top="Size.xs"
                                        >
                                            <div>
                                                <svg-icon
                                                    :icon="MessageMinusIcon"
                                                    :size="IconSize.xs"
                                                    :color="'gray-400'"
                                                    is-custom-icon
                                                />
                                            </div>
                                            <div>
                                                <svg-icon
                                                    :icon="MessageLinesIcon"
                                                    :size="IconSize.xs"
                                                    :color="'gray-400'"
                                                    is-custom-icon
                                                />
                                            </div>
                                        </flex-container>
                                        <flex-container
                                            align-items="center"
                                            align-content="space-around"
                                            :gap="Size.sm"
                                            class="text-content"
                                            :size="'auto'"
                                        >
                                            <flex-container align-items="center" :gap="Size.sm">
                                                <template v-if="editingQuickOptionEN?.id === option.id">
                                                    <input-group
                                                        v-model.trim="editingQuickOptionEN.englishShortMessage"
                                                        :schema="englishValidationSchema"
                                                    >
                                                        <template #input>
                                                            <text-input />
                                                        </template>
                                                    </input-group>
                                                </template>
                                                <template v-else>
                                                    <text-decorator>
                                                        {{ option.englishShortMessage ?? 'Engelse variant ontbreekt' }}
                                                    </text-decorator>
                                                </template>
                                            </flex-container>

                                            <horizontal-line
                                                v-if="editingQuickOptionEN?.id !== option.id"
                                                no-margin
                                            />

                                            <flex-container
                                                align-items="center"
                                                :gap="Size.sm"
                                            >
                                                <template v-if="editingQuickOptionEN?.id === option.id">
                                                    <input-group
                                                        v-model.trim="editingQuickOptionEN.englishMessage"
                                                        :schema="englishValidationSchema"
                                                    >
                                                        <template #input>
                                                            <text-input />
                                                        </template>
                                                    </input-group>
                                                </template>
                                                <template v-else>
                                                    <text-decorator>
                                                        {{ option.englishMessage ?? 'Engelse variant ontbreekt' }}
                                                    </text-decorator>
                                                </template>
                                            </flex-container>
                                        </flex-container>
                                    </flex-container>
                                </template>
                            </flex-container>
                            <flex-container
                                :size="1"
                                :gap="Size.lg"
                                direction="column"
                                justify-content="center"
                                align-content="center"
                            >
                                <button-plain-icon
                                    v-if="editingQuickOptionNL?.id === option.id"
                                    :icon="CheckIcon"
                                    :color="'green-500'"
                                    :size="IconSize.sm"
                                    :disabled="!quickOptionsBindings.isValid.value"
                                    @click="saveQuickOption"
                                />
                                <button-plain-icon
                                    v-else
                                    :icon="EditIcon"
                                    :color="'primary'"
                                    :size="IconSize.sm"
                                    @click="editQuickOption(index)"
                                />
                                <button-plain-icon
                                    :icon="DeleteIcon"
                                    :color="'red-500'"
                                    :size="IconSize.sm"
                                    @click="deleteQuickOption(index)"
                                />
                            </flex-container>
                        </flex-container>
                    </form-validation>
                </template>
            </card-expandable>
        </template>
    </flex-container>
</template>

<script setup lang="ts">
    import {
        CountryFlag,
        FormValidation,
        FlexContainer,
        IconSize,
        InputGroup,
        Size,
    } from '@keyvue/one-ui';
    import { computed, ref } from 'vue';
    import type { QuickOption } from '@keyvue/one-api-client';
    import EditIcon from '@keyvue/one-material-icons/icons/edit.svg?component';
    import CheckIcon from '@keyvue/one-material-icons/icons/check.svg?component';
    import DeleteIcon from '@keyvue/one-material-icons/icons/delete.svg?component';
    import MessageMinusIcon from '@keyvue/one-awesome-icons/icons/regular/message-minus.svg?component';
    import MessageLinesIcon from '@keyvue/one-awesome-icons/icons/regular/message-lines.svg?component';
    import { string } from 'yup';

    interface Props {
        quickOptions: QuickOption[]
        englishSupportEnabled: boolean
    }

    const props = defineProps<Props>();

    const emit = defineEmits<{
        (e: 'option:add', value: string): void;
        (e: 'option:delete', value: number): void;
    }>();

    const localQuickOptions = ref(props.quickOptions);

    const editingQuickOptionNL = ref<QuickOption | null>(null);
    const editingQuickOptionEN = ref<QuickOption | null>(null);

    const englishValidationSchema = computed(() => {
        if (props.englishSupportEnabled) {
            return string().max(255).required();
        }
        return null;
    });

    function editQuickOption(index: number) {
        editingQuickOptionNL.value = localQuickOptions.value[index];

        if (props.englishSupportEnabled) {
            editingQuickOptionEN.value = localQuickOptions.value[index];
        }
    }

    function saveQuickOption(): void {
        editingQuickOptionNL.value = null;
        editingQuickOptionEN.value = null;
    }

    function deleteQuickOption(index: number) {
        emit('option:delete', index);
    }
</script>

<style scoped lang="scss">
.option-item {
    display: flex;
    align-items: center;

    border: 1px solid color(gray-200);
    border-radius: size(sm);
    --card--border-width: 1px;
    --card--box-shadow: none;
}

.text-content {
    flex: 1;
    text-align: left;
    word-break: break-word;
    min-width: initial !important;
}
</style>
